import React, { useEffect } from 'react'
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom'
import {
  fetchCourseLmsData,
  fetchCourseLmsToken,
  fetchAssessments,
} from '../actions'
import { routePaths } from '../urls'
import { useStateValue } from '@State'
import { LoadingSpinner } from '@CommonComponents'

import { Canvas } from './Canvas'
import { Brightspace } from './Brightspace'
import { Navigation } from './Navigation'

export const Application = () => {
  const [state, dispatch] = useStateValue()

  useEffect(() => {
    fetchCourseLmsData(dispatch)
    fetchCourseLmsToken(dispatch)
    fetchAssessments(dispatch)
  }, [])

  let redirectPath
  switch (state.selectedLms) {
    case 'canvas_v2':
      redirectPath = routePaths.canvas
      break
    case 'brightspace':
      redirectPath = routePaths.brightspace
      break
  }

  if (!state.selectedLms) return <LoadingSpinner />

  return (
    <Router>
      <div
        id="body_section"
        className="row position-relative p-0 my-5 mx-3 mx-sm-5"
      >
        <h2 className="me-page-title mt-5">LMS Integration</h2>
        <section id="body_section_left_column" className="col-md-6 pl-0 mt-5">
          <Navigation />
        </section>

        <section id="body_section_center" className="mt-3 pt-3 col-md-18">
          <Route
            exact
            path={routePaths.root}
            render={() => <Redirect to={redirectPath} />}
          />
          <Route path={routePaths.canvas} component={Canvas} />
          <Route path={routePaths.brightspace} component={Brightspace} />
        </section>
      </div>
    </Router>
  )
}
